import React from 'react';
import { IonActionSheet } from '@ionic/react';

interface DeleteTopicSheetProps {
  topicTitle: string;
  isOpen: boolean;
  onDismiss: () => void;
  onDelete: () => void;
}

/** Confirmation action sheet for deleting a topic. */
const DeleteTopicSheet: React.FC<DeleteTopicSheetProps> = ({
  topicTitle,
  isOpen,
  onDismiss,
  onDelete,
}) => (
  <IonActionSheet
    isOpen={isOpen}
    onDidDismiss={onDismiss}
    header={`Delete "${topicTitle}"?`}
    buttons={[
      {
        text: 'Delete Topic',
        role: 'destructive',
        handler: onDelete,
      },
      {
        text: 'Cancel',
        role: 'cancel',
      },
    ]}
  />
);

export default DeleteTopicSheet;
